// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__c27Ce","modal-show":"Modal_modal-show__nNzYK","openModal":"Modal_openModal__2la5D","modal-bg-show":"Modal_modal-bg-show__kb4nQ"};